import NotificationCard from "./notification-card";

export default NotificationCard;